module.exports = __webpack_public_path__ + "img/reward_1.3a22c9b6.png";